import React, { useState } from 'react';
import catalog from '../../Images/catalog.png';
import '../../Styles/Catalog2.css';
import { useNavigate } from "react-router-dom";
import WishlistButton from "./WishlistBtn";
import { IoShareSocial, IoPlayCircle } from "react-icons/io5";
import Swal from "sweetalert2";

export default function Catalog2(props) {
  const navigate = useNavigate();
  const [showShareModal, setShowShareModal] = useState(false);

  const viewCourse = () => {
    navigate(`/Course/${props.courseId}`);
  };

  const handleTrailer = (e) => {
    if (e) e.stopPropagation();
    // Add your trailer handling logic here
    if (props.trailer) {
      // Open trailer modal or redirect to trailer page
      console.log('Opening trailer:', props.trailer);
    }
  };

  const handleShare = (e) => {
    if (e) e.stopPropagation();
    
    const courseUrl = `${window.location.origin}/course/${props.courseId}`;
    
    if (navigator.share) {
      navigator.share({
        title: props.coursetitle,
        text: `Check out this course: ${props.coursetitle}`,
        url: courseUrl,
      }).catch((error) => {
        console.log('Error sharing:', error);
      });
    } else {
      // Fallback: Copy to clipboard
      navigator.clipboard.writeText(courseUrl)
        .then(() => {
          Swal.fire({
            icon: 'success',
            title: 'Link Copied!',
            text: 'Course link copied to clipboard',
            timer: 1500,
            showConfirmButton: false,
            position: 'top-end'
          });
        })
        .catch((err) => {
          console.error('Failed to copy: ', err);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to copy link to clipboard',
            confirmButtonColor: '#B8529E'
          });
        });
    }
  };

  return (
    <div className="listview"> 
      <div className="card mb-2" style={{ 
        border: 'none', 
        display: 'flex', 
        flexDirection: 'row', 
        height: '200px',
        position: 'relative'
      }}> 
        
        {/* Wishlist and Share Icons (Top Right) */}
        <div style={{
          position: "absolute",
          top: "70px",
          right: "7px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          zIndex: 2
        }}>
          
          
          {/* Share Button */}
          <div 
            onClick={handleShare}
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
              transition: "all 0.3s ease",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "white";
              e.currentTarget.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.9)";
              e.currentTarget.style.transform = "scale(1)";
            }}
            title="Share course"
          >
            <IoShareSocial style={{ color: "#666", fontSize: "16px" }} />
          </div>
        </div>

        {/* Image section */}
        <div className="col-md-4 col-sm-12" style={{ padding: '0', overflow: 'hidden' }}>
          <img 
            src={props.cover_img || catalog} 
            className="img-fluid" 
            alt="Course Thumbnail" 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'cover',
              borderRadius: '8px 0 0 8px'
            }}
            onError={(e) => {
              e.target.src = catalog;
            }}
          />
        </div>

        {/* Content section */}
        <div className="col-md-8 col-sm-12 cat2card-body" style={{ 
          padding: '20px', 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'space-between' 
        }}>
          <div>
            <h5 className="cat2card-title" style={{ 
              color: '#2C3E50', 
              fontWeight: '600', 
              marginBottom: '10px',
              fontSize: '18px'
            }}>
              {props.coursetitle}
            </h5>
            
            <p className="card-description" style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "block",
              color: '#666',
              marginBottom: '8px',
              fontSize: '14px'
            }}>
              {props.description}
            </p>
            
            <div style={{ 
              display: 'flex', 
              gap: '15px', 
              flexWrap: 'wrap', 
              marginBottom: '10px' 
            }}>
              {props.category && (
                <span style={{
                  backgroundColor: '#FFF0E6',
                  color: '#f4811e',
                  fontSize: '12px',
                  fontWeight: '500',
                  padding: '4px 8px',
                  borderRadius: '6px'
                }}>
                  {props.category}
                </span>
              )}
              
              <p className="card-date" style={{ 
                color: '#666', 
                fontSize: '13px', 
                margin: '0',
                display: 'flex',
                alignItems: 'center'
              }}>
                📅 {props.start_date}
              </p>
            </div>

            <p className="card-instructor" style={{ 
              color: '#666', 
              fontSize: '13px', 
              marginBottom: '0' 
            }}>
              <strong style={{ color: '#B8529E' }}>Instructor:</strong> {props.instructor}
            </p>
          </div>

          {/* Action buttons */}
          <div className="cbutton d-flex justify-content-between align-items-center flex-wrap" style={{ marginTop: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              {/* Price */}
              <span style={{ 
                color: '#f4811e', 
                fontWeight: '700',
                fontSize: '16px'
              }}>
                {props.price === 0 || props.price === "$0" ? "FREE" : `₹${props.price}`}
              </span>
              
              {/* Trailer Button - Only show if trailer prop exists */}
              {props.trailer && (
                <button
                  className="btn btn-sm"
                  onClick={handleTrailer}
                  style={{
                    backgroundColor: "transparent",
                    color: "#f4811e",
                    borderRadius: "6px",
                    padding: "6px 12px",
                    fontSize: "13px",
                    fontWeight: "500",
                    border: "1px solid #f4811e",
                    transition: "all 0.3s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f4811e";
                    e.currentTarget.style.color = "white";
                    e.currentTarget.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#f4811e";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                  title="Watch trailer"
                >
                  <IoPlayCircle style={{ fontSize: "14px" }} />
                  Trailer
                </button>
              )}
              
              {/* View Course Button */}
              <button 
                className="btn-shared"
                onClick={viewCourse}
                style={{
                  backgroundColor: '#B8529E',
                  color: 'white',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#9a3a7f';
                  e.target.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#B8529E';
                  e.target.style.transform = 'translateY(0)';
                }}
              > 
                View Course
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}